import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { FeatureInfo } from 'projects/leaflet/src/lib/interfaces/feature-info';
import { PlatformInfo } from 'projects/leaflet/src/lib/interfaces/platform-info';
import { Map } from 'projects/leaflet/src/lib/map';
import { LayerFilterCategory } from 'projects/leaflet/src/public-api';
import { FilterDialogService } from './filters-dialog/filter-dialog.service';
import { LoaderService } from './loader/loader.service';
import { ConfigService } from './services/config.service';
import { Subject } from 'rxjs';
import { FilterService } from './services/filter.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { RotteService } from './services/rotte.service';
import { PlatformsInfoPopupService } from './platforms-info-popup/platforms-info-popup.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [

    trigger('openCloseMenu', [
      state(
        'open',
        style({
          right: '0px',
        })
      ),
      state(
        'closed',
        style({
          right: '-305px',
        })
      ),
      transition('open => closed', [animate('0.5s')]),
      transition('closed => open', [animate('0.5s')]),
    ]),
    trigger('openCloseInfo', [
      state(
        'open',
        style({
          left: '10px',
        })
      ),
      state(
        'closed',
        style({
          left: '-300%',
        })
      ),
      transition('open => closed', [animate('1s')]),
      transition('closed => open', [animate('1s')]),
    ]),
  ],
})
export class AppComponent implements OnInit {
  @ViewChild('componentPlaceholder', { read: ViewContainerRef, static: true })
  public componentPlaceholder?: ViewContainerRef;
  @ViewChild('leaflet', { static: true })
  elementMap?: ElementRef<HTMLDivElement>;
  map?: Map;

  menuVisible: boolean = true;
  listVisible: boolean = false;
  institutionVisible: boolean = true;
  wmsLayerLoading: boolean = false;
  platformInfoLoading: boolean = false;
  featureInfoLoading: boolean = false;
  featureInfoVisible: boolean = false;
  categories?: LayerFilterCategory[];
  normalizedCategories?: LayerFilterCategory[];
  platformInfo: PlatformInfo[] = [];
  featureInfo?: FeatureInfo[];
  newCategoreis: Array<any> = []
  categoryId: string = '';
  layerObject: any;
  bathymetricObject: any;
  customFilters: Array<any> = [];
  hitsoption: Array<any> = [];
  institutions: Array<any> = [];
  polygon: any;
  cqlfilterInstitution: Subject<string> = new Subject<string>();
  baselayer: any;
  featuresInfo: any[] = [];

  get token() {
    return this.OAuth.getAccessToken();
  }

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private platformInfoService: PlatformsInfoPopupService,
    public dialogService: FilterDialogService,
    private loaderService: LoaderService,
    private filterService: FilterService,
    private OAuth: OAuthService,
  ) { }
  ngOnInit(): void {

    if (this.elementMap) {
      this.map = new Map(this.elementMap, this.http, {
        showZoom: true
      });
      this.configService.getConfigFiles().subscribe((x) => {
        this.layerObject = x[1];
        this.customFilters = x[4];
        // && this.token
        if (this.token) {
          const authid = this.OAuth.getIdentityClaims()['sub'];
          this.filterService.getLoggedfilter(authid).subscribe(
            (res: any) => {
              const valueJson = JSON.parse(res.value);
              const sanitized = this.customFilterSanitizer([valueJson]);
              const deepSanitized = JSON.parse(JSON.stringify(sanitized));
              localStorage.setItem('custom-filter', res.value);
              x[2].push(...deepSanitized);
            },
            (error) => {
              console.log('Error on get filter saved', error);
            }
          )
        } else if (localStorage.length > 0 && localStorage.getItem('custom-filter')) {
          const localFilters = JSON.parse(localStorage.getItem('custom-filter')!);
          x[2].push(localFilters);
        }
        this.polygon = x[5];
        this.institutions = x[6];

        this.newCategoreis = this.categoriesSanitizer(x[2]);
        this.categories = this.newCategoreis;
        let layers = this.layerObject[0];
        this.baselayer = this.layerObject;
        this.map?.addBaseLayers(x[0]);
        this.map?.addOverlayLayers(layers, this.newCategoreis, x[3]);

        this.cqlfilterInstitution.subscribe((cqi) => (cqi));

        this.map?.addPolygonOverlay([], this.polygon);
        this.mapOverlayFor();
        this.map?.addGeoJsonRadar(x[7]);
      });
      this.filterService.filters.subscribe((filter) => {
        const sanitized = this.customFilterSanitizer([filter]);
        const deepSanitized = JSON.parse(JSON.stringify(sanitized));
        if (this.categories!.length >= 8) {
          const itemToPush = deepSanitized[0]?.categories?.[deepSanitized[0].categories.length - 1];
          if (itemToPush) {
            this.categories![this.categories!.length - 1].categories!.push(itemToPush);
          }
        } else {
          this.categories?.push(...deepSanitized);
        }
      })

    }
  }

  public mapOverlayFor() {
    this.map?.overlayLayers.forEach((x: any) => {
      x.loading.subscribe((x: any) => {
        this.loaderService.show(x);
        this.wmsLayerLoading = x;
      });
      x.featureInfoLoading.subscribe((x: any) => (this.featureInfoLoading = x, this.loaderService.show(x),console.log('test', x)));
      x.platformsInfoLoading.subscribe(
        (x: any) => {
          this.platformInfoLoading = x;
        });

      x.platformsInfoChanged.subscribe((s: any) => (this.platformInfo = s));

      x.featureInfoChanged.subscribe((s: any) => {
        if(s.featureInfo.length > 0){
        this.platformInfoService.SetPlatformInfo(s);
        this.featureInfoVisible = true;
        } else {
          this.featureInfoVisible = false;
        }
      });
    });
  }

  categoriesSanitizer(category: Array<any>) {
    for (let item of category) {

      if (item.categories && item.categories.length > 0) {
        if (item.id) {
          this.categoryId = item.id
        }
        this.categoriesSanitizer(item.categories)
      }
      if (item.filters) {
        if (this.categoryId == 'platform type') {
          let text = item.filters;
          let first = text.indexOf("'");
          let second = text.indexOf("'", first + 1);
          let diff = second - first;
          let code = text.substr(first + 1, diff - 1);
          item.filters = [{ layerName: 'platforms', value: item.filters, code: code }];
        } else {
          item.filters = [{ layerName: 'platforms', value: item.filters }];
        }
      }
    }
    return category;
  }

  customFilterSanitizer(categories: Array<any>): Array<any> {
    const sanitize = (items: Array<any>, parentId?: string): Array<any> => {
      return items.map(item => {
        const currentId = item.id || parentId;

        const sanitizedItem = { ...item };
        if (item.categories && Array.isArray(item.categories)) {
          sanitizedItem.categories = sanitize(item.categories, currentId);
        }

        // Sanitize filters
        if (item.filters && !Array.isArray(item.filters)) {
          const rawValue = item.filters;
          if (currentId === 'platform type') {
            const first = rawValue.indexOf("'");
            const second = rawValue.indexOf("'", first + 1);
            const code = rawValue.substring(first + 1, second);

            sanitizedItem.filters = [{
              layerName: 'platforms',
              value: rawValue,
              code: code
            }];
          } else {
            sanitizedItem.filters = [{
              layerName: 'platforms',
              value: rawValue
            }];
          }
        }

        return sanitizedItem;
      });
    };

    const result = sanitize(categories);
    return result;
  }

  institutionsSelected(event: any) {
    this.map?.updateOverlayMapCqlFilter(event);
  }

  institutionToAdd(ids: any) {
    if (ids.length > 0) {
      this.map?.addPolygonOverlay(ids, this.polygon);
      this.map?.addOverlayLayers(this.baselayer, this.newCategoreis, this.hitsoption);
    }
  }
}
